import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import style from '../css/Agents.module.css';
import AdminBottomTab from './AdminBottomTab';
import HeaderBar from '../components/HeaderBar';

const Agents = () => {
	const [agents, setAgents] = useState([]); // Store agents
	const [loading, setLoading] = useState(true); // Show loader
	const [error, setError] = useState(null); // Handle errors
	const navigate = useNavigate();

	// Fetch Agents
	const fetchAgents = async () => {
		setLoading(true);
		try {
			const response = await fetch(
				'https://hometech-repairs.in/homeTech/fetchAllAgents.php'
			);
			const data = await response.json();

			if (data.data) {
				setAgents(data.data);
				setError(null);
			} else {
				setError('No agents available.');
			}
		} catch (error) {
			setError('Failed to load agents.');
			console.error('Error fetching agents:', error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchAgents();
	}, []);

	if (loading) {
		return <div className={style.loader}>Loading...</div>;
	}

	return (
		<div className={style.container}>
			<HeaderBar title={'Agents'} />
			{error && <p className={style.error}>{error}</p>}

			{agents.length === 0 ? (
				<p className={style.noData}>No agents available.</p>
			) : (
				<ul className={style.agentList}>
					{agents.map((agent) => (
						<li
							key={agent.agent_id}
							className={style.agentItem}
							onClick={() => navigate(`/agent-detail/${agent.id}`)}
						>
							<div>
								<p className={style.agentId}>{agent.agent_id}</p>
								<p className={style.agentName}>{agent.name}</p>
							</div>
							<p
								className={
									agent.status === 'Active' ? style.active : style.inactive
								}
							>
								{agent.status}
							</p>
						</li>
					))}
				</ul>
			)}

			<button
				className={style.addAgentButton}
				onClick={() => navigate('/add-agent')}
			>
				+
			</button>
			<AdminBottomTab />
		</div>
	);
};

export default Agents;
